import { AlterSituacaoEnum, SituacaoRestricEnumRegistro, PerfilRestrictEnumRegistro, TipoMensagem, CabecalhoMensagens, MensagensPadrao, SituacaoPerfilRestricEnumRegistro, PerfilSituacaoRestricEnumRegistro } from "../enums/Enumarations";
import { BaseImplemantation } from './base-system-implementation';
import * as FileSaver from 'file-saver';
/**
 * Implementação da Interface sistema para o sistema Registro para restrição de acesso ao usuário.
 */
export class RegistroImplementation extends BaseImplemantation {
    situacaoAlter = AlterSituacaoEnum;
    perfilRestrict = PerfilRestrictEnumRegistro;
    situacaoRestric = SituacaoRestricEnumRegistro;
    situacaoPerfilRestric = SituacaoPerfilRestricEnumRegistro;
    perfilSituacaoRestric = PerfilSituacaoRestricEnumRegistro;

    undefinedMethod(value1?: any, value2?: any, value3?: any, value4?: any, value5?: any, value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) {
        if (value1 == 'exportar-excel' || value1 == 'exportar-pdf') return true;
        else return false;
    };

    dataTableFunction(event?: any, eventSelection?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any) {

        filtro.dataSetName = `DataSet${filtro.possui == 'delegacia' ? 'RegistroDelegacia' : 'RegistroDelegaciaCidade'}`;
        filtro.nameReport = filtro.possui == 'delegacia' ? 'RegistroDelegacia' : 'RegistroDelegaciaCidade';
        this.reportConfig.formatReport = 'PDF';
        switch (event.button) {
            case 'exportar-excel':
                this.reportConfig.formatReport = 'Excel';
                this.generateReport(`delegacia/gerarRelatorio/${localStorage.getItem('lotacao')}`, Object.assign({}, this.reportConfig, filtro));
                break;
            case 'exportar-pdf':
                this.generateReport(`delegacia/gerarRelatorio/${localStorage.getItem('lotacao')}`, Object.assign({}, this.reportConfig, filtro));
                break;
            case 'gerar-comprovante':
                if (event.selection.situacao.id != 9)
                    this.generateReport('documentoEmitido/gerarComprovante', null, event.selection['id']);
                else
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], 'Registro cancelado. Comprovante não pode ser emitido.');
                break;
            case 'cancelar':
                if (event.selection['id_situacao'] != 9) {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente cancelar este registro?`,
                        accept: () => {
                            this.service.Atualizar(controllerName, { id: event.selection['id'], id_situacao: 9 }, { parcial: "id_situacao" }).subscribe(
                                () => {
                                    listagem.refresh(filtro);
                                    this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], `Registro cancelado com sucesso.`);
                                },
                                err => this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], `Houve um erro ao cancelar o registro. ${err._body}`)
                            );
                        }
                    })
                } else {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], 'Registro já foi cancelado.');
                }
                break;
            default:
                this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[11]);
                break;
        }
    }

    generateReport(rota: string, filtro: any, value: any = null) {
        this.observableUtilPanel.setBlockedPanel(true);
        this.service.Relatorio(rota, value, filtro).subscribe(
            data => {
                FileSaver.saveAs(new Blob([data.blob()], { type: data['_body'].type }));
                this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], 'Documento gerado com sucesso');
            },
            error => {
                this.observableUtilPanel.setBlockedPanel(false);
                this.reader.addEventListener('loadend', (e) => {
                    this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], e.srcElement['result']);
                });
                this.reader.readAsText(error._body);
            },
            () => { this.observableUtilPanel.setBlockedPanel(false); }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/registro-system-implementation.ts